// Em App.jsx
import CustomMuiTable from './CustomMuiTable';
import { Chip, Button, Box } from '@mui/material';

const DATA = [
    { id: 1, name: 'João Silva', status: 'Ativo', project: 45000, progress: 80 },
    { id: 2, name: 'Maria Souza', status: 'Pendente', project: 78000, progress: 30 },
    { id: 3, name: 'Pedro Alves', status: 'Concluído', project: 12000, progress: 100 },
];

const COLUMNS = [
    { field: 'name', headerName: 'Nome do Colaborador' },
    {
        field: 'status',
        headerName: 'Status',
        // Exemplo de renderização personalizada de célula (usando MUI Chip)
        renderCell: (row) => (
            <Chip
                label={row.status}
                color={
                    row.status === 'Ativo'
                        ? 'success'
                        : row.status === 'Pendente'
                            ? 'warning'
                            : 'default'
                }
                size="small"
            />
        ),
    },
    {
        field: 'project',
        headerName: 'Valor (R$)',
        align: 'right', // Alinhamento de números à direita
        // Formatação de valor
        renderCell: (row) => `R$ ${row.project.toLocaleString('pt-BR')}`,
    },
    {
        field: 'actions',
        headerName: 'Ações',
        align: 'center',
        // Componente de Ação
        renderCell: (row) => (
            <Button variant="outlined" size="small" sx={{ textTransform: 'none' }}>
                Ver Detalhes
            </Button>
        ),
    },
];

const CustomMuiTableUsage = () => (
    <Box sx={{ p: 4 }}>
        <CustomMuiTable columns={COLUMNS} data={DATA} />
    </Box>
);

export default CustomMuiTableUsage;